import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { Instagram, Youtube, Music2 } from 'lucide-react';
import { MAIN, formatNum } from '../data';

const PlatformCard = ({ entry, icon: Icon, accent }) => (
    <GlassCard>
        <div className="flex items-center justify-between mb-5">
            <div className={`${accent} px-3 py-1.5 rounded-full inline-flex items-center gap-2`}>
                <Icon size={14} />
                <span className="text-xs font-bold uppercase tracking-wider">{entry.platform}</span>
            </div>
        </div>
        <p className="text-white/40 text-xs font-mono mb-6 truncate">{entry.handle}</p>
        <div>
            <p className="text-white/40 text-[10px] uppercase tracking-widest font-semibold mb-1">Views</p>
            <p className="text-3xl font-black text-white tracking-tight mb-5">{formatNum(entry.views)}</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
            <div>
                <p className="text-white/40 text-[10px] uppercase tracking-widest font-semibold mb-1">Likes</p>
                <p className="text-xl font-black text-white tracking-tight">{formatNum(entry.likes)}</p>
            </div>
            <div>
                <p className="text-white/40 text-[10px] uppercase tracking-widest font-semibold mb-1">Comments</p>
                <p className="text-xl font-black text-white tracking-tight">{formatNum(entry.comments)}</p>
            </div>
        </div>
    </GlassCard>
);

export const MainPageStats = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-6xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">The Flagship</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">Main Page — The Mask with Abhiveer</h2>
                <p className="text-white/50 text-center mb-12 max-w-xl mx-auto">
                    The page every fan account feeds, across all three platforms.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                    <PlatformCard entry={MAIN.ig} icon={Instagram} accent="bg-pink-500/15 text-pink-300" />
                    <PlatformCard entry={MAIN.yt} icon={Youtube} accent="bg-red-500/15 text-red-300" />
                    <PlatformCard entry={MAIN.tt} icon={Music2} accent="bg-cyan-500/15 text-cyan-300" />
                </div>
            </div>
        </section>
    );
};
